import { render, staticRenderFns } from "./StackedChart.vue?vue&type=template&id=4284f8ea&"
import script from "./StackedChart.vue?vue&type=script&lang=js&"
export * from "./StackedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports